/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.27.13
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const FeatureFlag = {
    claim_forms: 'claim-forms',
    coupons: 'coupons',
    spin_to_win: 'spin-to-win',
    ticket_cost_multiplier: 'ticket-cost-multiplier',
    unknown_default_open_api: '11184809'
} as const;
export type FeatureFlag = typeof FeatureFlag[keyof typeof FeatureFlag];


export function instanceOfFeatureFlag(value: any): boolean {
    for (const key in FeatureFlag) {
        if (Object.prototype.hasOwnProperty.call(FeatureFlag, key)) {
            if (FeatureFlag[key as keyof typeof FeatureFlag] === value) {
                return true;
            }
        }
    }
    return false;
}

export function FeatureFlagFromJSON(json: any): FeatureFlag {
    return FeatureFlagFromJSONTyped(json, false);
}

export function FeatureFlagFromJSONTyped(json: any, ignoreDiscriminator: boolean): FeatureFlag {
    return json as FeatureFlag;
}

export function FeatureFlagToJSON(value?: FeatureFlag | null): any {
    return value as any;
}

